import api from '@/api'
import notifications from '@/api/apiSferest/services/notifications'

export const getList = ({ commit, state, getters, dispatch }) => {
  dispatch('loading')
  return new Promise((resolve, reject) => {
    let params = {
      ...getters['query'],
      sort: state.search.sort,
      limit: state.search.limit
    }
    notifications.list(params)
    .then((res) => {
      commit('list/SET_LIST', res.data)
      resolve()
      dispatch('loaded')
    })
  })
}

export const getAvailableDelegations = ({ commit }) => {
  return new Promise((resolve, reject) => {
    notifications.delegations()
    .then((res) => {
      commit('SET_AVAILABLE_DELEGATIONS', res.data)
      resolve(res)
    })
  })
}

export const create = ({ commit, getters, state }) => {
  return new Promise((resolve, reject) => {
    let data = getters.apificate
    notifications.create(state.delegation, data)
    .then((res) => {
      commit('CLEAN_FORMS')
      resolve()
    })
  })
}

export const update = ({ commit, getters }, idD) => {
  return new Promise((resolve, reject) => {
    let data = getters.apificate
    notifications.update(idD, data)
    .then((res) => {
      commit('CLEAN_FORMS')
      resolve()
    })
  })
}

export const empty = ({commit, dispatch}) => {
  return new Promise((resolve, reject) => {
    var forms = ['billToPay', 'autoBillToCharge', 'billToCharge', 'autoBillToPay']
    commit('SAVE_DELEGATION', null)
    Promise.all([
      forms.map((key) => {
        return dispatch(`${key}/emptyForm`)
      })
    ]).then(() => {
      resolve()
    })
  })
}

const desapificate = (n) => {
  return {
    email: n.email,
    emited: n.onIssued,
    read: n.onRead,
    accepted: n.onAccepted,
    refused: n.onRejected,
    edited: n.onRectified,
    ignored: n.afterSevenDays,
    language: 1
  }
}

export const get = ({ dispatch }, value) => {
  return new Promise((resolve, reject) => {
    notifications.get(value)
    .then((res) => {
      let data = {
        billToCharge: res.data.issuedInvoices ? desapificate(res.data.issuedInvoices) : null,
        billToPay: res.data.receivedInvoices ? desapificate(res.data.receivedInvoices) : null,
        autoBillToCharge: res.data.issuedSelfinvoices ? desapificate(res.data.issuedSelfinvoices) : null,
        autoBillToPay: res.data.receivedSelfinvoices ? desapificate(res.data.receivedSelfinvoices) : null
      }
      dispatch('setForm', data)
      resolve(data)
    })
  })
}

export const setForm = ({ commit }, value) => {
  return new Promise((resolve, reject) => {
    for (var prop in value) {
      let info = {key: prop, value: value[prop]}
      commit('SET_UP_FORMS', info)
    }
    resolve()
  })
}

export const getMore = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.apiSferest.get(state.search.more, { data: {} })
    .then((res) => {
      if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
        reject(new Error('Error de conexión'))
        return
      }
      commit('list/ADD_TO_LIST', res.data)
      commit('search/SET_MORE', res.headers['x-next-page'])
      resolve(res.data)
    })
  })
}

export const resetParams = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_NAME', '')
    commit('SET_EMAIL', '')
    commit('search/SET_MORE', undefined)
    commit('search/SET_LIMIT', 10)
    commit('search/SET_SORT', undefined)
    resolve()
  })
}

export const loading = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', false)
    resolve(false)
  })
}

export const loaded = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', true)
    resolve(true)
  })
}

export const remove = ({ commit }, selected) => {
  return new Promise((resolve, reject) => {
    notifications.remove(selected.map(x => x.id))
    .then((res) => {
      resolve(res)
    })
  })
}
